import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    padding: theme.spacing(0, 1),
  },
});

const StepSeparator = ({
  className,
  classes,
}) => {
  return (
    <Typography
      className={classNames(classes.root, className)}
      variant={'h6'}
      color={'mediumDarkGray'}
    >
      {'•'}
    </Typography>
  );
};

StepSeparator.defaultProps = {
  className: '',
};

StepSeparator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StepSeparator);
